export default __webpack_public_path__ + "media/images/landing-33-550x420-dc696a35995f65db377c2f8ee364380e.jpg";